import { render, staticRenderFns } from "./userDropdownMenu.vue?vue&type=template&id=65d9b877&scoped=true"
import script from "./userDropdownMenu.vue?vue&type=script&lang=js"
export * from "./userDropdownMenu.vue?vue&type=script&lang=js"
import style0 from "./userDropdownMenu.vue?vue&type=style&index=0&id=65d9b877&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d9b877",
  null
  
)

export default component.exports